import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check, ArrowRight, CreditCard } from 'lucide-react';
export function BonusTwoSection() {
  const includes = ['12 cierres suaves listos para copiar/pegar (ordenados por perfil)', 'Cierres por tipo de comprador: decidido, inseguro, regateador, ocupado', 'Cómo responder "¿me hacés precio?" sin bajar estatus', 'Plantilla "Cierre A/B" (para que el prospecto elija sin escapar)', 'Los 5 errores que matan el cierre (y sus reemplazos exactos)'];
  const bullets = ['"¿Te paso el link y listo?" (el cierre más simple que existe)', 'Cómo pedir el pago sin que suene a presión', '4 cierres para el que dice "lo pienso" (sin rogar)', 'La diferencia entre cerrar con A/B y cerrar con precio suelto', 'Qué decir cuando ya aceptó y no manda el pago'];
  return <section className="w-full bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-8 pt-[40px] pb-[40px]" data-id="element-171">
      <div className="max-w-6xl mx-auto" data-id="element-172">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-173">
          {/* Text — LEFT */}
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-5 order-2 lg:order-1" data-id="element-174">
            {/* Badge */}
            <div className="flex items-center gap-2" data-id="element-175">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#0B6B3A] text-white text-sm font-bold rounded-full" data-id="element-176">
                <Gift className="w-4 h-4" data-id="element-177" />
                BONO #2 — GRATIS
              </span>
              <span className="text-sm text-[#6B7280] line-through" data-id="element-178">$17</span>
            </div>

            {/* Title */}
            <div data-id="element-179">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#1A1A1A] leading-tight mb-2" data-id="element-180">
                Cierres Suaves: 12 Formas de Pedir el Pago Sin Incomodar
              </h2>
              <p className="text-lg text-[#6B7280] font-medium flex items-center gap-2" data-id="element-181">
                <CreditCard className="w-4 h-4 text-[#0B6B3A]" data-id="element-182" />
                Para cuando el "me interesa" no termina en pago
              </p>
            </div>

            {/* Hook */}
            <p className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-183">
              Ya filtraste al prospecto. Ya le mostraste el valor. Te dijo "me
              interesa". Y ahí… te trabás. No sabés cómo pedir el pago sin sonar
              desesperado. Terminás diciendo{' '}
              <strong data-id="element-184">"cualquier cosa avisame"</strong> y la venta muere.
            </p>

            {/* Problem scenario */}
            <div className="bg-white border-l-4 border-[#0B6B3A] rounded-r-xl p-5 shadow-sm" data-id="element-185">
              <p className="text-sm font-bold text-[#1A1A1A] mb-2 uppercase tracking-wide" data-id="element-186">
                El problema real:
              </p>
              <p className="text-sm text-[#6B7280] leading-relaxed" data-id="element-187">
                Muchos negocios pierden ventas no en la objeción, sino{' '}
                <strong className="text-[#1A1A1A]" data-id="element-188">
                  después de la objeción
                </strong>
                . Cuando el prospecto ya dijo "está bien" y el vendedor no supo
                cerrar.
              </p>
            </div>

            {/* Includes */}
            <div data-id="element-189">
              <p className="text-sm font-bold text-[#1A1A1A] uppercase tracking-wide mb-3" data-id="element-190">
                Lo que incluye:
              </p>
              <ul className="space-y-2" data-id="element-191">
                {includes.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.07
              }} className="flex items-start gap-2.5 text-sm text-[#1A1A1A]" data-id="element-192">
                    <Check className="w-4 h-4 text-[#0B6B3A] mt-0.5 flex-shrink-0" data-id="element-193" />
                    {item}
                  </motion.li>)}
              </ul>
            </div>

            {/* Value justification */}
            <p className="text-sm text-[#6B7280] italic border-t border-gray-100 pt-4" data-id="element-194">
              Si hoy se te escapan 2 ventas por semana por no cerrar bien, eso
              es dinero que ya estaba casi en tu bolsillo. Con 1 solo cierre que
              antes perdías y hoy ganás, este bono se paga infinito.
            </p>

            {/* Bullets */}
            <ul className="space-y-1.5" data-id="element-195">
              {bullets.map((b, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#6B7280]" data-id="element-196">
                  <ArrowRight className="w-3.5 h-3.5 text-[#0B6B3A] mt-0.5 flex-shrink-0" data-id="element-197" />
                  {b}
                </li>)}
            </ul>

            <p className="text-xs text-[#6B7280] font-medium" data-id="element-198">
              Formato: mini-guía PDF + scripts copiables. Acceso inmediato.
            </p>
          </motion.div>

          {/* Image — RIGHT */}
          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="flex justify-center lg:justify-end order-1 lg:order-2" data-id="element-199">
            <div className="relative max-w-xs w-full" data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/j8C2edeCsknfhR1rX53Bzi/bono_2_cierres_suaves.png" alt="Bono 2: Cierres Suaves" className="w-full h-auto object-contain drop-shadow-xl rounded-lg" data-id="element-201" />
              <div className="absolute -top-3 -left-3 bg-[#0B6B3A] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg" data-id="element-202">
                Valor: $17
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}